import { render } from "./ContentFallback.vue?vue&type=template&id=4ce1f917&scoped=true&ts=true"
import script from "./ContentFallback.vue?vue&type=script&lang=ts"
export * from "./ContentFallback.vue?vue&type=script&lang=ts"

import "./ContentFallback.vue?vue&type=style&index=0&id=4ce1f917&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce1f917"]])

export default __exports__